module.exports = __webpack_public_path__ + "img/date-picker.70f055fb.png";